import { Route } from 'react-router-dom';
import UserSessionContextWrapper from './UserSessionContextWrapper';
import IdleTracker from './idle-tracker/IdleTracker';
import Header from './Header/Header';
import { isMobile } from '../services/DeviceInformation';

export default function AuthenticatedRoute({ children }) {
    return (
        <Route>
            <UserSessionContextWrapper>
                <IdleTracker />
                {!isMobile() && <Header />}
                {children}
            </UserSessionContextWrapper>
        </Route>
    );
}
